export enum AllowOrder {
  FOR_INFO,
  SELECTABLE,
  BY_QUANTITY,
}
